import { useSetAtom } from "jotai";
import {
  fetchTasksAtom,
  completeTaskAtom,
  addTaskAtom,
  updateTaskAtom,
  duplicateTaskAtom,
  generateCategoryImagesAtom,
  saveRecurringTaskAtom,
  deleteRecurringTaskAtom,
} from "../../store/actions.js";

// Task Action Hooks
export const useTaskActions = () => {
  const fetchTasks = useSetAtom(fetchTasksAtom);
  const completeTask = useSetAtom(completeTaskAtom);
  const addTask = useSetAtom(addTaskAtom);
  const updateTask = useSetAtom(updateTaskAtom);
  const duplicateTask = useSetAtom(duplicateTaskAtom);
  const generateCategoryImages = useSetAtom(generateCategoryImagesAtom);
  const saveRecurringTask = useSetAtom(saveRecurringTaskAtom);
  const deleteRecurringTask = useSetAtom(deleteRecurringTaskAtom);

  return {
    fetchTasks,
    completeTask,
    addTask,
    updateTask,
    duplicateTask,
    generateCategoryImages,
    saveRecurringTask,
    deleteRecurringTask,
  };
};
